import React from 'react';

interface FooterProps {
  onNavigateToLegal?: (page: 'regulamin' | 'polityka-prywatnosci' | 'polityka-cookies') => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigateToLegal }) => {
  return (
    <footer className="bg-gray-50 pt-16 pb-8 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-10 flex items-center justify-center gap-2 opacity-80">
          <div className="rounded-lg bg-gray-400 p-1.5">
            <svg
              className="h-5 w-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="text-sm font-extrabold tracking-tight text-gray-700">
            KALKULATOR JDG
          </span>
        </div>

        <nav className="mb-10 flex flex-wrap justify-center gap-x-10 gap-y-4 text-sm font-medium">
          <button
            type="button"
            onClick={() => onNavigateToLegal?.('regulamin')}
            className="text-gray-500 transition-colors hover:text-gray-900"
          >
            Regulamin
          </button>
          <button
            type="button"
            onClick={() => onNavigateToLegal?.('polityka-prywatnosci')}
            className="text-gray-500 transition-colors hover:text-gray-900"
          >
            Polityka prywatności
          </button>
          <button
            type="button"
            onClick={() => onNavigateToLegal?.('polityka-cookies')}
            className="text-gray-500 transition-colors hover:text-gray-900"
          >
            Polityka cookies
          </button>
          <a
            href="mailto:kalkulatorjdg@gmail.com"
            className="text-gray-500 transition-colors hover:text-gray-900"
          >
            Kontakt
          </a>
          <a
            href="https://blog.kalkulatorjdg.pl"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 transition-colors hover:text-gray-900"
          >
            Blog
          </a>
        </nav>

        <div className="border-t border-gray-200 pt-8">
          <p className="mb-2 text-sm text-gray-400">
            © 2025-2026 KalkulatorJDG.pl. Wszelkie prawa zastrzeżone.
          </p>
          <p className="mx-auto max-w-2xl text-xs italic text-gray-400">
            Dane mają charakter informacyjny i nie stanowią porady prawnej ani podatkowej.
            Zawsze konsultuj się z doradcą podatkowym lub księgowym przed podjęciem decyzji.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
